module.exports = __webpack_public_path__ + "img/green-arrow.bbfdfab6.svg";